
import AboutUs from "../components/about us/AboutUs";
import Navbar from "../components/navbar/Navbar";
import "../components/cart/Cart.css"
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";
import { useEffect } from "react";

const About = () => {
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <div className="bg-imagea">
            <Navbar />
            <Banner title="About" />
            <AboutUs />
            <Footer />
        </div>
    )
}
export default About;






